import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { PieChart } from "react-minimal-pie-chart";
import {
  CaretUpOutlined,
  CaretDownOutlined,
  MoreOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import {
  DashboardOutlined,
  SwapOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  DatePicker,
  Space,
  Select,
  Modal,
  Spin,
  Dropdown,
  Alert,
  Popover,
  Tooltip as tooltip,
} from "antd";
import beatingheart from "../components/beatingheart.json";
import green from "../components/Green.json";
import down from "../components/down.json";
import orange from "../components/Orange.json";
import up from "../components/up.json";
import chart from "../assets/images/chart.svg";
import diagram from "../assets/images/diagram.svg";
import download from "../assets/images/download.svg";
import { Card, Button } from "antd";

import { CustomTooltip } from "./CustomTooltip";
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
import Lottie from "lottie-react";
import { CSVLink } from "react-csv";
import * as htmlToImage from "html-to-image";
import {
  XAxis,
  YAxis,
  Bar,
  BarChart,
  Legend,
  CartesianGrid,
  Line,
  Tooltip,
  LineChart,
  ResponsiveContainer,
} from "recharts";

import Example from "./multipleselectDropdown";
import { get, post } from "../Libraries/Ajax/HttpService";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { useDistrict } from "../utils/DistrictContext";

function Home() {
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { Option } = Select;
  const [defaultOption, setDefaultOption] = useState("Year");
  const [defaultOptionss, setDefaultOptionss] = useState("Category");
  const [first, setFirst] = useState(false);
  const [sixth, setSixth] = useState("gallons");
  const [optionone, setOptionone] = useState(null);
  const [optiontwo, setOptiontwo] = useState(null);
  const [pre, setPre] = useState(null);
  const [thisr, setThisr] = useState(null);
  // const [mySample, setmySample] = useState(["145330-"]);
  const [optionthree, setOptionthree] = useState(false);
  const [msgopen, setmsgopen] = useState(false);
  const [optionfour, setOptionfour] = useState(true);
  const [response, setResponse] = useState([]);
  const [callData, setcallData] = useState([]);
  const [msg, setmsg] = useState([]);
  const [toggle, setToggle] = useState(false);
  const [systemHealth, setSystemHealth] = useState(null);
  const [systemCommunication, setSystemCommunication] = useState(null);
  const [systemDevice, setSystemDevice] = useState(null);
  const [systemData, setSystemData] = useState(null);
  const [selected, setSelected] = useState("Last Month");
  const [percentage, setPercentage] = useState(null);
  const [arrayData, setArrayData] = useState(null);
  const [spindata, setSpindata] = useState(null);
  const [backflow, setBackflow] = useState(null);
  const [noissue, setNoissue] = useState(null);
  const [noissueper, setNoissueper] = useState(null);
  const [backflowper, setBackflowper] = useState(null);
  const [leakper, setLeakper] = useState(null);
  const [noflow, setNoflow] = useState(null);
  const [leak, setLeak] = useState(null);
  const [last, setLast] = useState(null);
  const [update, setUpdate] = useState(null);
  const [next, setNext] = useState(null);
  const [recent, setRecent] = useState(null);
  const [sum, setSum] = useState(0);
  const [date, setDate] = useState(0);
  const [sumname, setSumname] = useState(0);
  const [inactive, setInactive] = useState(0);
  const [allocated, setAllocated] = useState(0);
  const [totaluse, setTotaluse] = useState(0);
  const [capacityname, setCapacityname] = useState(0);
  const [allocatedcapacity, setAllocatedcapacity] = useState(0);
  const [totalcapacitylimit, setTotalcapacitylimit] = useState(0);
  const [limit, setLimit] = useState(0);
  const [use, setUse] = useState(0);
  const currentYear = new Date().getFullYear();
  const prev = new Date().getFullYear() - 1;
  const currentDate = new Date();
  const startDate = new Date(currentDate.getFullYear(), 0, 1);
  var days = Math.floor((currentDate - startDate) / (24 * 60 * 60 * 1000));
  const [parameterone, setParameterone] = useState(prev);
  const [parametertwo, setParametertwo] = useState(currentYear);
  const [parameterthree, setParameterthree] = useState(prev);
  const [parameterfour, setParameterfour] = useState(currentYear);
  const [stringone, setStringone] = useState();
  const [stringtwo, setStringtwo] = useState();
  const [stringthree, setStringthree] = useState();
  const [stringfour, setStringfour] = useState();
  const { RangePicker } = DatePicker;
  // const [myData, setmyData] = useState([]);
  // const [myDatas, setmyDatas] = useState([]);
  const [myDatasex, setmyDatasex] = useState([]);
  const [myDatanew, setmyDatanew] = useState([]);
  const [merge, setMerge] = useState([null]);
  const [test, setTest] = useState([]);
  const [listOfUsers, setListofUsers] = useState([]);
  const [listOfUser, setListofUser] = useState([]);
  const [status, setStatus] = useState([true]);
  const [color, setColor] = useState([]);
  const [messagecount, setMessagecount] = useState(0);
  const [count, setCount] = useState(0);
  const [inc, setInc] = useState(0);
  const [isTooltipVisible, setTooltipVisible] = useState(false);

  const [accountability, setAccountability] = useState(null);
  const [yearlyConsumption, setYearlyConsumption] = useState(null);

  const controller = new AbortController();
  const signal = controller.signal;
  const arryDatass = [];
  const domEl = useRef(null);
  const safeValue = (v) => (isNaN(v) || v === undefined ? 0 : v);

  const defaultStartYear = dayjs().subtract(1, "year").startOf("year");
  const defaultEndYear = dayjs().startOf("year");
  const selectedDistrict = useDistrict();
  const mcData = JSON.parse(localStorage.getItem("MCData"));
  const initialDistrict = mcData?.selectedDistrict || "GPMD";

  // Set initial values based on district
  const defaultMeterId = initialDistrict === "FB151" ? "288433" : "145330";
  const defaultMeterParam = initialDistrict === "FB151" ? "288433-" : "145330-";
  const defaultName =
    initialDistrict === "FB151" ? "429700" : "Potable Domestic";
  const defaultOverride =
    initialDistrict === "FB151" ? "429700" : "PHMSCM Holdings";
  const defaultCode = initialDistrict === "FB151" ? "DKRP0" : "DKRP1";

  // Update these State declarations in your Home() function:
  const [mySample, setmySample] = useState([defaultMeterParam]);
  const [myData, setmyData] = useState([defaultMeterId]);
  const [myDatas, setmyDatas] = useState([
    {
      // colours: "#1F77B4", // Default color
      meter: defaultMeterId,
      overide: defaultOverride,
      code: defaultCode,
      name: defaultName,
    },
  ]);
  // useEffect(() => {
  //   if (!selectedDistrict?.selectedDistrict) return;
  //   else {
  //     setmySample([]);
  //     setMerge([]);
  //     setmyData([]);
  //     setmyDatas([]);
  //     setmyDatanew([]);
  //   }
  // }, [selectedDistrict]);
  useEffect(() => {
    if (!selectedDistrict?.selectedDistrict) return;

    // 1. Clear old data to prevent "ghost" data from the previous district
    setmySample([]);
    setmyData([]);
    setMerge(null);
    setmyDatas([]); // Clear the legend
    setmyDatasex([]); // Clear the dashed legend

    const district = selectedDistrict.selectedDistrict;
    const defaultColor = color[0] || "#1F77B4"; // Fallback to blue if color array isn't loaded

    // 2. Set defaults based on the specific district
    let config = {
      param: "",
      paramex: "",
      name: "",
      code: "",
      override: "",
    };

    if (district === "FB151") {
      config = {
        param: "288433-",
        paramex: "288433",
        name: "429700",
        code: "DKRP0",
        override: "429700",
      };
    } else if (district === "GPMD") {
      config = {
        param: "145330-",
        paramex: "145330",
        name: "Potable Domestic",
        code: "DKRP1",
        override: "PHMSCM Holdings",
      };
    }

    if (config.param) {
      // 3. Update plotting state
      setmySample([config.param]);
      setmyData([config.paramex]);

      // Generate the padded ID for the dashed line (Year 2 comparison)
      let paddedMeter = padWithZero(
        config.paramex,
        String(config.paramex).length + 5,
      );
      setmyDatanew([paddedMeter]);

      // 4. CRITICAL FIX: Update the Legend objects so Recharts finds the correct data keys
      setmyDatas([
        {
          colours: defaultColor,
          meter: config.paramex,
          overide: config.override,
          code: config.code,
          name: config.name,
        },
      ]);

      setmyDatasex([
        {
          colours: defaultColor,
          meters: paddedMeter,
          overide: config.override,
          code: config.code,
          name: config.name,
        },
      ]);

      // Force UI sync
      setCount((prev) => prev + 1);
    }
  }, [selectedDistrict, color]); // Added color to dependencies
  useEffect(() => {
    var user = JSON.parse(localStorage.getItem("MCData"));
    var userid = user?.userid;
    get(`apis/user_color?user_id=${userid}`).then((response) => {
      setColor(response.data.color);
    });
  }, []);
  const disabledDate = (current) => {
    return current && current > dayjs().endOf("day");
  };
  const downloadImage = async () => {
    const dataUrl = await htmlToImage.toPng(domEl.current);

    // download image
    const link = document.createElement("a");
    link.download =
      parameterone?.toString() +
      "-" +
      parametertwo?.toString() +
      "-" +
      JSON.parse(localStorage.getItem("MCData"))?.selectedDistrict?.toString();
    link.href = dataUrl;
    link.click();
  };
  const downloadImages = async () => {
    if (myData.length > 0) {
      const dataUrl = await htmlToImage.toPng(domEl.current);

      // download image
      const link = document.createElement("a");
      link.download =
        parameterthree?.toString() +
        "-" +
        parameterfour?.toString() +
        "-" +
        JSON.parse(
          localStorage.getItem("MCData"),
        )?.selectedDistrict?.toString();
      link.href = dataUrl;
      link.click();
    } else {
      toast.info("Please select account before download");
    }
  };
  const items = [
    {
      label: (
        <a href="#" onClick={downloadImage}>
          Download As PNG
        </a>
      ),
      key: "0",
    },
    {
      type: "divider",
    },
    {
      label: (
        <button className="csvlink">
          {" "}
          <CSVLink
            data={listOfUsers}
            filename={
              parameterone?.toString() +
              "-" +
              parametertwo?.toString() +
              "-" +
              JSON.parse(
                localStorage.getItem("MCData"),
              )?.selectedDistrict?.toString()
            }
          >
            Download As CSV
          </CSVLink>
        </button>
      ),

      key: "1",
    },
  ];
  const item = [
    {
      label: (
        <a href="#" onClick={downloadImages}>
          Download As PNG
        </a>
      ),
      key: "0",
    },
    {
      type: "divider",
    },
    {
      label: (
        <button className="csvlink">
          {" "}
          <CSVLink
            data={listOfUser}
            filename={
              parameterthree.toString() +
              "-" +
              parameterfour.toString() +
              "-" +
              JSON.parse(
                localStorage.getItem("MCData"),
              )?.selectedDistrict?.toString()
            }
          >
            Download As CSV
          </CSVLink>
        </button>
      ),

      key: "1",
    },
  ];

  const fetchSystemBattery = async () => {
    try {
      const res = await get("apis/system_battery");
      const data = res?.data?.data;

      setSystemHealth(data.system_health);
      setSystemCommunication(data.comm_status);
      setSystemData(data.data_status);
      setSystemDevice(data.device_status);
      setNext(data.next);
      setLast(data.last);
      setUpdate(data.updated_by);
    } catch (error) {
      console.error("Error fetching system battery data:", error);
    }
  };

  useEffect(() => {
    fetchSystemBattery();
  }, [selectedDistrict]);

  useEffect(() => {
    const fetchFlowHealthData = async () => {
      try {
        const res = await get("apis/flow_health");
        const flowData = res?.data?.data?.flow_data_per || {};

        setBackflow(flowData.backflow);
        setNoissue(flowData.no_issue);
        setNoissueper(flowData.no_issue_per);
        setLeak(flowData.leak);
        setRecent(flowData.no_recent_flow);
        setBackflowper(flowData.backflow_per);
        setLeakper(flowData.leak_per);
        setNoflow(flowData.no_recent_per);

        setFirst(true);
      } catch (error) {
        console.error("Error fetching flow health data:", error);
      }
    };

    // if (!first) {
    fetchFlowHealthData();
    // }
  }, [selectedDistrict]);

  useEffect(() => {
    const fetchSystemUsage = async () => {
      try {
        const response = await get(`apis/system_usage?option=${selected}`);
        const usage = response?.data?.data?.systemusage;

        if (usage) {
          setPercentage(usage.percentage);
          setOptionone(usage.flow);
          setOptiontwo(usage.flow_pre);
          setOptionthree(usage.percentage);
          setOptionfour(usage.percentage_arrow_down);
          setPre(usage.pre_range);
          setThisr(usage.this_range);
        }
      } catch (err) {
        throw err;
      }
    };
    fetchSystemUsage();
  }, [selected, selectedDistrict]);

  useEffect(() => {
    const fetchYearlyConsumption = async () => {
      try {
        const res = await get(`apis/all_year_consumption`);
        const data = res?.data?.data?.consumption;

        setSpindata(data);
        if (data) {
          setYearlyConsumption({
            demand: data.demand_total_consumption_total_sum,
            produced: data.produced_total_consumption_sum,
            supply: data.supply_total_consumption_sum,
          });
        }
      } catch (error) {
        console.error("Error fetching yearly consumption:", error);
        throw error;
      }
    };

    fetchYearlyConsumption();
  }, [selectedDistrict]);

  const fetchManualRefresh = async () => {
    try {
      const response = await get(`apis/manual_refresh`);
      const data = response?.data;
      setmsg(data?.msg);
      setStatus(!data?.status); // if status is true, disable button
    } catch (error) {
      console.error("API fetch error:", error);
    }
  };

  useEffect(() => {
    // initial fetch
    fetchManualRefresh();

    // interval polling
    const interval = setInterval(fetchManualRefresh, 300000); // 5 minutes
    return () => clearInterval(interval); // cleanup
  }, [selectedDistrict]);

  useEffect(() => {
    const fetchAccountabilityData = async () => {
      try {
        const res = await get(`apis/accountability_dashboard`);
        const data = res?.data?.data;

        if (data) {
          setSpindata(data);

          setAccountability({
            nonPotable: data.average_non_potable,
            potable: data.average_potable,
            total: data.average_total,
          });
        }
      } catch (error) {
        console.error("Error fetching accountability dashboard data:", error);
        throw error;
      }
    };

    fetchAccountabilityData();
  }, [selectedDistrict]);

  useEffect(() => {
    console.log("selectedDistrict", selectedDistrict);
    if (!selectedDistrict?.selectedDistrict) return;

    const fetchCapacityData = async () => {
      try {
        const res = await get(`apis/capactiy?unit=${sixth}`);
        if (res?.data?.data) {
          setSpindata(res.data.data);
          setInactive(res.data.data.total_capacity);
          setAllocated(res.data.data.allocated_capacity);
          setCapacityname(res.data.data.allocated_capacity_name);
          setUse(res.data.data.total_flow_365_days_sum);
          setLimit(res.data.data.total_limit_capacity);
          setAllocatedcapacity(res.data.data.total_capacity_name);
          setTotaluse(res.data.data.total_flow_365_days_name);
          setTotalcapacitylimit(res.data.data.total_limit_capacity_name);
          setSumname(res.data.data.total_flow_365_days_max_sum_name);
          setSum(res.data.data.total_flow_365_days_max_sum);
          setDate(res.data.data.total_flow_365_days_max_date);
        }
      } catch (error) {
        console.error("Error fetching capacity data:", error);
        setSpindata(null);
      }
    };

    fetchCapacityData();
  }, [sixth, selectedDistrict]);

  // let history = useHistory();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTrendData = async () => {
      const isYearMode = defaultOption === "Year" && parameterone?.length === 4;
      const isMonthMode =
        defaultOption === "Month" && parameterone?.includes("-"); // e.g., "2025-01"
      if (defaultOption === "Day" && parameterone.toString().length === 4) {
        return;
      }
      // If we just switched to Month, but parameters are still Years (2025/2026), STOP.
      if (defaultOption === "Month" && !parameterone?.includes("-")) {
        return;
      }
      if (parameterone && parametertwo && defaultOptionss === "Category") {
        try {
          const res = await get(
            `apis/trend?option_value=${defaultOption}&start=${parameterone}&end=${parametertwo}&start_week=${stringone}&end_week=${stringtwo}`,
          );

          const trendData = res?.data?.data?.trend || [];
          const formattedData = trendData.map((item) => ({
            name: item.option_name,
            [parameterone]: item.first_option_sum,
            [parametertwo]: item.second_option_sum,
          }));

          setListofUsers(res?.data?.data?.download_trend);
          setArrayData(formattedData);
        } catch (error) {
          console.error("Trend API error:", error);
          setArrayData(null);
        }
      }
    };

    fetchTrendData();
  }, [
    parameterone,
    parametertwo,
    defaultOptionss,
    defaultOption,
    stringone,
    stringtwo,
    selectedDistrict,
  ]);

  useEffect(() => {
    if (
      parameterthree != null &&
      parameterfour != null &&
      mySample.length > 0
    ) {
      if (defaultOptionss != "Category" && myDatas.length < 9) {
        get(
          `apis/download_account_trend?option_value=${defaultOption}&start=${parameterthree}&end=${parameterfour}&start_week=${stringthree}&end_week=${stringfour}&meterid=${JSON.stringify(
            mySample,
          )}`,
        ).then((response) => {
          setListofUser(response.data);
        });
      }
    }
  }, [mySample, parameterthree, parameterfour, selectedDistrict]);

  useEffect(() => {
    if (parameterthree == null && defaultOptionss == "Account") {
      toast.info("Please choose a date", {
        toastId: "success1",
      });
      setMerge(null);
    }
    if (
      parameterthree != null &&
      parameterfour != null &&
      mySample.length > 0
    ) {
      if (defaultOptionss != "Category" && myDatas.length < 9) {
        get(
          `apis/account_trend?option_value=${defaultOption}&start=${parameterthree}&end=${parameterfour}&start_week=${stringthree}&end_week=${stringfour}&meterid=${JSON.stringify(
            mySample,
          )}`,
          {
            signal: signal,
          },
        )
          .then((res) => {
            res.data.data.map((item) => {
              // console.log(item[0].option_name)
              let name = item[0]?.option_name;
              const meterData = Object.fromEntries(
                item?.map(({ meter_id, option }) => [meter_id, option]),
              );

              const weeklyMeterDatas = { name, ...meterData };

              arryDatass.push(weeklyMeterDatas);

              setTimeout(() => {
                setMerge(arryDatass);
              }, 1000);
            });
          })
          .catch((error) => {
            setMerge(null);
          });
        return () => {
          // cancel the request before component unmounts

          controller.abort();
        };
      }
    } else if (parameterthree != null && parameterfour == null) {
      if (defaultOptionss != "Category") {
        get(
          `apis/account_trend?option_value=${defaultOption}&start_week=${stringthree}&end_week=${stringfour}&start=${parameterthree}&meterid=${JSON.stringify(
            mySample,
          )}`,
        )
          .then((res) => {
            res.data.data.map((item) => {
              let name = item[0]?.option_name;
              const meterData = Object.fromEntries(
                item?.map(({ meter_id, option }) => [meter_id, option]),
              );

              const weeklyMeterDatas = { name, ...meterData };

              arryDatass.push(weeklyMeterDatas);

              setTimeout(() => {
                setMerge(arryDatass);
              }, 1000);
            });
          })
          .catch((error) => {
            setMerge(null);
          });
      }
    }
  }, [myData, parameterthree, parameterfour, selectedDistrict]);

  const barClick = () => {
    setToggle(false);
  };
  const handleCancel = () => {
    setOpen(false);
  };
  const onMouseClick = (event) => {
    setSelected(event.target.value);
  };
  const onMouseClickcapacity = (event) => {
    setSixth(event.target.value);
  };
  const handleOk = () => {};
  const lineClick = () => {
    setToggle(true);
  };
  const refreshClick = (e) => {
    e.stopPropagation();

    setmsgopen(true);
    post(`apis/manual_refresh?manual=start`).then((response) => {
      setmsg(response?.data?.msg);

      // toast.info(response?.data?.msg);
    });
    //
  };
  function padWithZero(num, targetLength) {
    return String(num).padStart(targetLength, "0");
  }
  const onchange = (value, dateString) => {
    setParameterone(dateString[0]);
    setParametertwo(dateString[1]);
    setStringone(value[0]._d);
    setStringtwo(value[1]._d);
  };
  const onchanges = (value, dateString) => {
    setStringthree(value._d);

    setParameterthree(dateString);
  };
  const onchangess = (value, dateString) => {
    setParameterfour(dateString);
    setStringfour(value._d);
    // console.log(parameterfour);
  };

  const onHealth = (event) => {
    // history.push('/health');
    navigate("/health");
  };
  // const totalFlow = (event) => {
  //  navigate("/flowhealth");
  // };
  const totalFlow = (key) => {
    navigate("/flowhealth", { state: { activeKey: key } });
  };
  const handleMenuClick = (e) => {
    if (e.key == 2) {
    }
  };
  const onSelect = (event) => {
    // setParameterfour(null);
    // setParameterthree(null);
    setArrayData(null);
    setMerge(null);
    toast.info("Please choose a date");
    if (event == "year") setDefaultOption("Year");
    else if (event == "month") setDefaultOption("Month");
    else if (event == "week") setDefaultOption("Week");
    else if (event == "quarter") setDefaultOption("Quarter");
    else if (event == "day") setDefaultOption("Day");
  };
  const onSelects = (event) => {
    setArrayData(null);
    setMerge([]);
    if (event == "account") {
      setDefaultOptionss("Account");

      // const param = "145330-";
      // const paramex = "145330";
      // const overrideName = "PHMSCM Holdings";
      // const meterCode = "DKRP1";
      // const meterName = "Potable Domestic";
      // const defaultColor = color[0] || "#1F77B4";

      // // 1. Trigger the API call (sets mySample)
      // setmySample([param]);

      // // 2. Set plotting keys for Year 1 (Solid Line)
      // setmyData([paramex]);

      // // 3. Set plotting keys for Year 2 (Padded ID for Dashed Line)
      // // padWithZero logic matches your 'add' function
      // let paddedMeter = padWithZero(paramex, String(paramex).length + 5);
      // setmyDatanew([paddedMeter]);

      // // 4. Populate the Legend and Selection Array
      // const initialSelection = {
      //   colours: defaultColor,
      //   meter: paramex,
      //   overide: overrideName,
      //   code: meterCode,
      //   name: meterName,
      // };
      // const initialSelectionPadded = {
      //   colours: defaultColor,
      //   meters: paddedMeter,
      //   overide: overrideName,
      //   code: meterCode,
      //   name: meterName,
      // };

      // setmyDatas([initialSelection]);
      // setmyDatasex([initialSelectionPadded]);

      // // 5. Increment count to ensure UI sync
      // setCount((prev) => prev + 1);
      const district = selectedDistrict?.selectedDistrict || "GPMD";
      const param = district === "FB151" ? "288433-" : "145330-";
      const paramex = district === "FB151" ? "288433" : "145330";
      const overrideName = district === "FB151" ? "429700" : "PHMSCM Holdings";
      const meterCode = district === "FB151" ? "DKRP0" : "DKRP1";
      const meterName = district === "FB151" ? "429700" : "Potable Domestic";

      const defaultColor = color[0] || "#1F77B4";

      setmySample([param]);
      setmyData([paramex]);

      let paddedMeter = padWithZero(paramex, String(paramex).length + 5);
      setmyDatanew([paddedMeter]);

      const initialSelection = {
        colours: defaultColor,
        meter: paramex,
        overide: overrideName,
        code: meterCode,
        name: meterName,
      };

      setmyDatas([initialSelection]);
      setCount((prev) => prev + 1);
    } else if (event == "category") {
      setDefaultOptionss("Category");
      setmyData([]);
      setmySample([]);
      setmyDatanew([]);
      setMerge([]);
      setmyDatas([]);
      setmyDatasex([]);
      setcallData([]);
    }
  };
  const call = (event) => {
    setInc(inc + 1);
  };
  const add = (param, paramex, overide, code, name, index, colour) => (e) => {
    // console.log("existingmydata",mySample);
    // console.log("existing",myData);
    if (mySample?.includes(param)) {
      var array = [...mySample];
      var index = array.indexOf(param);
      if (index !== -1) {
        array.splice(index, 1);

        setmySample(array);
      }
      console.log("llldelete", mySample);
    } else {
      if (myDatas.length < 8) {
        setmySample([...mySample, param]);
        console.log("llllllllll", mySample);
      }
    }

    if (myData?.includes(paramex)) {
      setMessagecount(messagecount - 1);
      setFirst(true);
      var array = [...myData];
      var arrays = [...myDatanew];
      var newarray = [...myDatas];
      var newarraynew = [...myDatasex];
      var index = array.indexOf(paramex);
      let meters = padWithZero(paramex, String(paramex).length + 5);
      var indexex = arrays.indexOf(meters);
      var inexnew = newarray.indexOf(paramex);

      if (index !== -1) {
        setMessagecount(messagecount - 1);
        array.splice(index, 1);
        newarray.splice(index, 1);
        setmyData(array);
        // uniqueNames = Array.from(new Set(myData));
        setmyDatas(newarray);

        setTest("test", newarray);
        // console.log("myData", myData);
        // console.log("myDatas", myDatas);
      }
      if (indexex !== -1) {
        newarraynew.splice(indexex, 1);
        arrays.splice(indexex, 1);
        setmyDatasex(newarraynew);
        setmyDatanew(arrays);
      }
    } else {
      if (myDatas.length < 8) {
        setMessagecount(messagecount + 1);
        const items = myData;
        const itemnew = myDatanew;
        const item = myDatas;
        let meter = paramex;
        let meters = padWithZero(paramex, String(paramex).length + 5);
        const colours = color[colour];
        setCount(count + 1);
        const arrays = { colours, meter, overide, code, name };
        const newarrays = { colours, meters, overide, code, name };
        myDatas.push(arrays);
        myDatasex.push(newarrays);
        setmyData([...items, paramex]);
        // uniqueNames = Array.from(new Set(myData));
        setTest(myDatas);
        setmyDatanew([...itemnew, meters]);
      } else {
        toast.info("Only 8 Meters can be selected at a time");
      }
    }
  };

  const handleCallback = (childData, res) => {
    setcallData(childData.data.data.meters.selected_meters);
    const productss = [];
    const productmysample = [];
    {
      childData?.data?.data?.meters?.selected_meters?.map((person) => {
        return (
          <div>
            {person.meters.map((persons, index) => {
              products.push(persons.meter_unique_name);
              productmysample.push(persons.unique_name);
              productss.push(
                padWithZero(
                  persons.meter_unique_name,
                  String(persons.meter_unique_name).length + 5,
                ),
              );
            })}
          </div>
        );
      });
    }
    setResponse(res);
    if (response.length > 0) {
      var ress = myData.filter((item) => products.includes(item));
      setmyData(ress);
      var resmysample = mySample.filter((item) =>
        productmysample.includes(item),
      );
      setmySample(mySample.filter((item) => productmysample.includes(item)));
      var resss = myDatanew.filter((item) => productss.includes(item));
      setmyDatanew(resss);
      var ressult = myDatas.filter((item) => products.includes(item.meter));

      setmyDatas(ressult);

      setTest(myDatas);
    }

    if (childData?.data?.data?.meters?.selected_meters?.length == 0) {
      setmyData([]);
      setmyDatanew([]);
      setMerge([]);
      setmyDatas([]);
      setmyDatasex([]);
      setmySample([]);
      // setcallData([]);
    }
  };

  const handleTooltipClick = (e) => {
    e.stopPropagation(); // Prevent the click from propagating
    setTooltipVisible(!isTooltipVisible); // Toggle tooltip visibility
  };

  const getYAxisLabel = () => {
    const kGallonPeriods = ["Year", "Month", "Week", "Quarter"];

    if (
      defaultOptionss === "Category" &&
      kGallonPeriods.includes(defaultOption)
    ) {
      return "Consumption (K Gallons)";
    }

    return "Consumption (Gallons)";
  };

  return (
    <>
      {/* <head>
        <title>
          {window.location.href.indexOf("mizuwatch.com") > -1
            ? "MizuWatch"
            : "MizuSmart"}
        </title>
      </head> */}
      <Header />
      <Main>
        {/* <button className="rounded border-info text-blue mb-3 bg-white ms-auto d-table py-1 px-2" onClick={modalclick}> */}
        {/* Add / Remove */}
        {/* </button> */}
        <div className="layout-content">
          <div className="container-fluid px-0 flex-column">
            <div className="row row-cols-3 g-3">
              <div className="col-12 col-lg">
                <Card
                  bordered={false}
                  className="h-full d-flex justify-content-between w-100 system-health-respo"
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <h2 className="text-blue mb-0 fw-bold h2-title">
                      System Health
                    </h2>
                  </div>

                  {systemHealth === null ? (
                    <Spin size="large" className="spinner" />
                  ) : (
                    <>
                      <div className="d-flex align-items-center flex-ph justify-content-center">
                        {systemHealth > 80 ? (
                          <div className="reg_heart" onClick={onHealth}>
                            {" "}
                            <Lottie
                              // options={defaultOptiongreen}
                              animationData={green}
                              // height={200}
                              // width={180}
                              loop={true}
                              style={{ height: 200, width: 180 }}
                              direction={-1}
                            />
                          </div>
                        ) : systemHealth > 60 && systemHealth < 80 ? (
                          <div className="reg_heart" onClick={onHealth}>
                            {" "}
                            <Lottie
                              // options={defaultOptionorange}
                              animationData={orange}
                              // height={200}
                              // width={180}
                              loop={true}
                              style={{ height: 200, width: 180 }}
                              direction={-1}
                            />
                            {/* <div className="border-orange text-orange text-center p-2 fs-18 rounded" onClick={onHealth}>Status: Alarming</div>
                          <button class="btn w-100 btn-submit fs-20 mt-20" onClick={refreshClick}

                          ><ReloadOutlined />Manual Refresh</button> */}
                          </div>
                        ) : systemHealth < 60 ? (
                          <div className="reg_heart" onClick={onHealth}>
                            {" "}
                            <Lottie
                              // options={defaultOptionsNews}
                              animationData={beatingheart}
                              // height={200}
                              // width={180}
                              loop={true}
                              style={{ height: 200, width: 180 }}
                              direction={-1}
                            />
                            {/* <div className="border-red text-red text-center p-2 fs-16 rounded" onClick={onHealth}>Status: UnHealthy</div>
                            <button class="btn w-100 btn-submit fs-20 mt-20" onClick={refreshClick}

                            ><ReloadOutlined />Manual Refresh</button> */}
                          </div>
                        ) : (
                          ""
                        )}

                        <div className="error-box gap-2" onClick={onHealth}>
                          {systemCommunication >= 80 ? (
                            <div className="d-flex mb-1">
                              <span className="bg-green"></span> Communication
                              Status
                              <Space style={{ marginLeft: "auto" }}>
                                <Popover
                                  trigger="click"
                                  content={
                                    <div
                                      style={{
                                        width: "250px",
                                        textAlign: "left",
                                      }}
                                    >
                                      Shows the overall communication status of
                                      meters based on last communication time
                                      and encoder communication errors.
                                    </div>
                                  }
                                  placement="top"
                                  getPopupContainer={(trigger) =>
                                    trigger.parentElement
                                  }
                                >
                                  <InfoCircleOutlined
                                    onClick={(e) => e.stopPropagation()} // Prevent event propagation to the parent
                                    style={{
                                      color: "#1890ff",
                                      cursor: "pointer",
                                      marginTop: "8px",
                                    }}
                                  />
                                </Popover>
                              </Space>
                            </div>
                          ) : systemCommunication < 80 &&
                            systemCommunication >= 60 ? (
                            <div className="d-flex mb-1">
                              <span className="bg-orange"></span> Communication
                              Status
                              <Space style={{ marginLeft: "auto" }}>
                                <Popover
                                  trigger="click"
                                  content={
                                    <div
                                      style={{
                                        width: "250px",
                                        textAlign: "left",
                                      }}
                                    >
                                      Shows the overall communication status of
                                      meters based on last communication time
                                      and encoder communication errors.
                                    </div>
                                  }
                                  placement="top"
                                  getPopupContainer={(trigger) =>
                                    trigger.parentElement
                                  }
                                >
                                  <InfoCircleOutlined
                                    onClick={(e) => e.stopPropagation()}
                                    style={{
                                      color: "#1890ff",
                                      cursor: "pointer",
                                      marginTop: "8px",
                                    }}
                                  />
                                </Popover>
                              </Space>
                            </div>
                          ) : systemCommunication < 60 ? (
                            <div className="d-flex mb-1">
                              <span className="bg-red"></span> Communication
                              Status
                              <Space style={{ marginLeft: "auto" }}>
                                <Popover
                                  trigger="click"
                                  content={
                                    <div
                                      style={{
                                        width: "250px",
                                        textAlign: "left",
                                      }}
                                    >
                                      Shows the overall communication status of
                                      meters based on last communication time
                                      and encoder communication errors.
                                    </div>
                                  }
                                  placement="top"
                                  getPopupContainer={(trigger) =>
                                    trigger.parentElement
                                  }
                                >
                                  <InfoCircleOutlined
                                    onClick={(e) => e.stopPropagation()}
                                    style={{
                                      color: "#1890ff",
                                      cursor: "pointer",
                                      marginTop: "8px",
                                    }}
                                  />
                                </Popover>
                              </Space>
                            </div>
                          ) : (
                            ""
                          )}
                          {systemData >= 80 ? (
                            <div className="d-flex mb-1">
                              <span className="bg-green"></span> Data Status
                              <Space style={{ marginLeft: "auto" }}>
                                <Popover
                                  trigger="click"
                                  content={
                                    <div
                                      style={{
                                        width: "250px",
                                        textAlign: "left",
                                      }}
                                    >
                                      Determined by the number of outliers
                                      detected in meter flow data over the last
                                      two weeks.
                                    </div>
                                  }
                                  placement="top"
                                  getPopupContainer={(trigger) =>
                                    trigger.parentElement
                                  }
                                >
                                  <InfoCircleOutlined
                                    onClick={(e) => e.stopPropagation()}
                                    style={{
                                      color: "#1890ff",
                                      cursor: "pointer",
                                      marginTop: "8px",
                                    }}
                                  />
                                </Popover>
                              </Space>
                            </div>
                          ) : systemData < 80 && systemData >= 60 ? (
                            <div className="d-flex mb-1">
                              <span className="bg-orange"></span> Data Status
                              <Space style={{ marginLeft: "auto" }}>
                                <Popover
                                  trigger="click"
                                  content={
                                    <div
                                      style={{
                                        width: "250px",
                                        textAlign: "left",
                                      }}
                                    >
                                      Determined by the number of outliers
                                      detected in meter flow data over the last
                                      two weeks.
                                    </div>
                                  }
                                  placement="top"
                                  getPopupContainer={(trigger) =>
                                    trigger.parentElement
                                  }
                                >
                                  <InfoCircleOutlined
                                    onClick={(e) => e.stopPropagation()}
                                    style={{
                                      color: "#1890ff",
                                      cursor: "pointer",
                                      marginTop: "8px",
                                    }}
                                  />
                                </Popover>
                              </Space>
                            </div>
                          ) : systemData < 60 ? (
                            <div className="d-flex mb-1">
                              <span className="bg-red"></span> Data Status
                              <Space style={{ marginLeft: "auto" }}>
                                <Popover
                                  trigger="click"
                                  content={
                                    <div
                                      style={{
                                        width: "250px",
                                        textAlign: "left",
                                      }}
                                    >
                                      Determined by the number of outliers
                                      detected in meter flow data over the last
                                      two weeks.
                                    </div>
                                  }
                                  placement="top"
                                  getPopupContainer={(trigger) =>
                                    trigger.parentElement
                                  }
                                >
                                  <InfoCircleOutlined
                                    onClick={(e) => e.stopPropagation()}
                                    style={{
                                      color: "#1890ff",
                                      cursor: "pointer",
                                      marginTop: "8px",
                                    }}
                                  />
                                </Popover>
                              </Space>
                            </div>
                          ) : (
                            ""
                          )}
                          {systemDevice >= 80 ? (
                            <div className="d-flex mb-1">
                              <span className="bg-green"></span> Device Status
                              <Space style={{ marginLeft: "auto" }}>
                                <Popover
                                  trigger="click"
                                  content={
                                    <div
                                      style={{
                                        width: "250px",
                                        textAlign: "left",
                                      }}
                                    >
                                      Shows the overall device status of meters
                                      based on endpoint tamper events, battery
                                      level, and signal strength.
                                    </div>
                                  }
                                  placement="top"
                                  getPopupContainer={(trigger) =>
                                    trigger.parentElement
                                  }
                                >
                                  <InfoCircleOutlined
                                    onClick={(e) => e.stopPropagation()}
                                    style={{
                                      color: "#1890ff",
                                      cursor: "pointer",
                                      marginTop: "8px",
                                    }}
                                  />
                                </Popover>
                              </Space>
                            </div>
                          ) : systemDevice < 80 && systemDevice >= 60 ? (
                            <div className="d-flex mb-1">
                              <span className="bg-orange"></span> Device Status
                              <Space style={{ marginLeft: "auto" }}>
                                <Popover
                                  trigger="click"
                                  content={
                                    <div
                                      style={{
                                        width: "250px",
                                        textAlign: "left",
                                      }}
                                    >
                                      Shows the overall device status of meters
                                      based on endpoint tamper events, battery
                                      level, and signal strength.
                                    </div>
                                  }
                                  placement="top"
                                  getPopupContainer={(trigger) =>
                                    trigger.parentElement
                                  }
                                >
                                  <InfoCircleOutlined
                                    onClick={(e) => e.stopPropagation()}
                                    style={{
                                      color: "#1890ff",
                                      cursor: "pointer",
                                      marginTop: "8px",
                                    }}
                                  />
                                </Popover>
                              </Space>
                            </div>
                          ) : systemDevice < 60 ? (
                            <div className="d-flex mb-1">
                              <span className="bg-red"></span> Device Status
                              <Space style={{ marginLeft: "auto" }}>
                                <Popover
                                  trigger="click"
                                  content={
                                    <div
                                      style={{
                                        width: "250px",
                                        textAlign: "left",
                                      }}
                                    >
                                      Shows the overall device status of meters
                                      based on endpoint tamper events, battery
                                      level, and signal strength.
                                    </div>
                                  }
                                  placement="top"
                                  getPopupContainer={(trigger) =>
                                    trigger.parentElement
                                  }
                                >
                                  <InfoCircleOutlined
                                    onClick={(e) => e.stopPropagation()}
                                    style={{
                                      color: "#1890ff",
                                      cursor: "pointer",
                                      marginTop: "8px",
                                    }}
                                  />
                                </Popover>
                              </Space>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <div className="d-flex justify-content-around w-100 align-items-center">
                        {systemHealth > 80 ? (
                          <>
                            <div
                              className="border-green text-green text-center fs-18 rounded "
                              style={{ padding: "6px 8px" }}
                              onClick={onHealth}
                            >
                              Status: Healthy
                            </div>{" "}
                            <div>
                              {" "}
                              {status === true ? (
                                <button
                                  className="btn  disable-manual w-100 fs-20 mt-0 manual-style d-flex align-items-center"
                                  disabled={status}
                                  onClick={(event) => refreshClick(event)}
                                >
                                  <ReloadOutlined className="pe-2" /> {msg}{" "}
                                </button>
                              ) : (
                                <button
                                  className="btn disable-manual w-100 fs-20 mt-0 manual-style d-flex align-items-center"
                                  // className="btn disable-manual  btn-submit w-100 fs-20 mt-0 manual-style d-flex align-items-center"
                                  disabled={status}
                                  onClick={(event) => refreshClick(event)}
                                >
                                  <ReloadOutlined className="pe-2" /> {msg}{" "}
                                </button>
                              )}{" "}
                            </div>
                          </>
                        ) : systemHealth > 60 && systemHealth < 80 ? (
                          <>
                            <div
                              className="border-orange text-orange text-center p-2 fs-18 rounded"
                              onClick={onHealth}
                            >
                              Status: Alarming
                            </div>{" "}
                            <div>
                              {" "}
                              {status === true ? (
                                <button
                                  className="btn  disable-manual w-100 fs-20 mt-0 manual-style d-flex align-items-center"
                                  disabled={status}
                                  onClick={(event) => refreshClick(event)}
                                >
                                  <ReloadOutlined className="pe-2" /> {msg}{" "}
                                </button>
                              ) : (
                                <button
                                  className="btn disable-manual  w-100 fs-20 mt-0 manual-style d-flex align-items-center"
                                  // className="btn disable-manual  btn-submit w-100 fs-20 mt-0 manual-style d-flex align-items-center"
                                  disabled={status}
                                  onClick={(event) => refreshClick(event)}
                                >
                                  <ReloadOutlined className="pe-2" /> {msg}{" "}
                                </button>
                              )}
                            </div>
                          </>
                        ) : systemHealth < 60 ? (
                          <>
                            <div
                              className="border-red text-red text-center p-2 fs-16 rounded"
                              onClick={onHealth}
                            >
                              Status: UnHealthy
                            </div>
                            <div>
                              {" "}
                              {status === true ? (
                                <button
                                  className="btn  disable-manual w-100 fs-20 mt-0 manual-style d-flex align-items-center"
                                  disabled={status}
                                  onClick={(event) => refreshClick(event)}
                                >
                                  <ReloadOutlined className="pe-2" /> {msg}{" "}
                                </button>
                              ) : (
                                <button
                                  className="btn disable-manual w-100 fs-20 mt-0 manual-style d-flex align-items-center"
                                  // className="btn disable-manual  btn-submit w-100 fs-20 mt-0 manual-style d-flex align-items-center"
                                  disabled={status}
                                  onClick={(event) => refreshClick(event)}
                                >
                                  <ReloadOutlined className="pe-2" /> {msg}{" "}
                                </button>
                              )}
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                      {update === "auto" ? (
                        <div className="updates-last w-100">
                          <span className="border-black text-black text-center p-1 fs-8 rounded">
                            Last Updated: {last}
                            <br />{" "}
                          </span>
                          <span className="border-black text-black text-center p-1 fs-8 rounded">
                            Next Update: {next}
                          </span>
                        </div>
                      ) : (
                        <div className="updates-last w-100">
                          <span className="border-black text-black text-center p-1 fs-8 rounded updates-last-manually">
                            Last Updated: {last}
                            <br />
                          </span>
                          <span className="border-black text-black text-center p-1 fs-8 rounded updates-last-manually">
                            Next Update: {next}
                          </span>
                        </div>
                      )}
                    </>
                  )}
                </Card>
              </div>
              <div className="col-12 col-lg">
                <Card
                  bordered={false}
                  className="criclebox h-full system-water"
                >
                  <div className="d-flex justify-content-between align-items-center pb-3">
                    <div class="d-flex justify-content-start align-items-center">
                      <h2 className="text-blue mb-0 fw-bold flex-grow-1 h2-title d-flex align-items-center me-2">
                        System Water Usage
                      </h2>
                      <Space className="me-3">
                        <Popover
                          trigger="click"
                          content={
                            <div
                              style={{
                                width: "250px",
                                textAlign: "left",
                              }}
                            >
                              This metric is calculated from networked meters
                              only
                            </div>
                          }
                          placement="top"
                          getPopupContainer={(trigger) => trigger.parentElement}
                        >
                          <InfoCircleOutlined
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              color: "#1890ff",
                              cursor: "pointer",
                              marginTop: "8px",
                            }}
                          />
                        </Popover>
                      </Space>
                    </div>
                    <select
                      name="All meters"
                      id="selector"
                      className="box custom-select"
                      style={{ height: "45px", lineHeight: "40px" }}
                      onChange={onMouseClick}
                    >
                      <option value="week">Week</option>
                      <option value="month">Month</option>
                      <option value="year">Year</option>
                      <option value="Last Week">Last 7 Days</option>
                      <option value="Last Month" selected>
                        Last 30 Days
                      </option>
                      <option value="Last Year">Last 365 Days</option>
                    </select>
                    <div className="dotted-dropdown">
                      {/* <MoreOutlined /> */}
                    </div>
                  </div>

                  {/* <h4 className="fw-400 text-grey mb-0">Weekly Usage(Gallons/Week)<span className="text-blue">*</span></h4> */}
                  {/* <p className="text-gray fw-400 fs-14">
                    <span className="text-blue">*</span>This metric is
                    calculated from networked meters only
                  </p> */}
                  <div className="d-flex justify-content-between flex-wrap new-wrap">
                    <div className="water-usage flex-column w-50 gap-3">
                      <Button type="btn" className="border-0 shadow-0 d-flex">
                        <div className="this_week">
                          {selected === "week" ? (
                            <>
                              <span className="txt-week">This Week </span>
                              <span className="txt-weeks">({thisr})</span>
                            </>
                          ) : (
                            ""
                          )}
                          {selected === "month" ? (
                            <>
                              <span className="txt-week">This Month </span>
                              <span className="txt-weeks">({thisr})</span>
                            </>
                          ) : (
                            ""
                          )}
                          {selected === "year" ? (
                            <>
                              <span className="txt-week">This Year </span>
                              <span className="txt-weeks">({thisr})</span>
                            </>
                          ) : (
                            ""
                          )}
                          {selected === "Last Week" ? (
                            <>
                              <span className="txt-week">Last 7 Days </span>
                              <span className="txt-weeks">({thisr})</span>
                            </>
                          ) : (
                            ""
                          )}
                          {selected === "Last Month" ? (
                            <>
                              <span className="txt-week">Last 30 Days </span>
                              <span className="txt-weeks">({thisr})</span>
                            </>
                          ) : (
                            ""
                          )}
                          {selected === "Last Year" ? (
                            <>
                              <span className="txt-week">Last 365 Days </span>
                              <span className="txt-weeks">({thisr})</span>
                            </>
                          ) : (
                            ""
                          )}

                          <span className="usage-numberNew">{optionone}</span>
                          <span className="txt-gallonNew">Gallons</span>
                        </div>
                      </Button>

                      <Button type="btn" className="border-0 shadow-0 d-flex">
                        <div className="last_week">
                          {selected === "week" ? (
                            <>
                              <span className="txt-week">Last Week</span>
                              <span className="txt-weeks">({pre})</span>
                            </>
                          ) : (
                            ""
                          )}
                          {selected === "month" ? (
                            <>
                              <span className="txt-week">Last Month </span>
                              <span className="txt-weeks">({pre})</span>
                            </>
                          ) : (
                            ""
                          )}
                          {selected === "year" ? (
                            <>
                              <span className="txt-week">Last Year </span>
                              <span className="txt-weeks">({pre})</span>
                            </>
                          ) : (
                            ""
                          )}
                          {selected === "Last Week" ? (
                            <>
                              <span className="txt-week">Previous 7 Days </span>
                              <span className="txt-weeks">({pre})</span>
                            </>
                          ) : (
                            ""
                          )}
                          {selected === "Last Month" ? (
                            <>
                              <span className="txt-week">
                                {" "}
                                Previous 30 Days{" "}
                              </span>
                              <span className="txt-weeks">({pre})</span>
                            </>
                          ) : (
                            ""
                          )}
                          {selected === "Last Year" ? (
                            <>
                              <span className="txt-week">
                                Previous 365 Days{" "}
                              </span>
                              <span className="txt-weeks">({pre})</span>
                            </>
                          ) : (
                            ""
                          )}

                          <span className="usage-numberNew">{optiontwo}</span>
                          <span className="txt-gallonNew">Gallons</span>
                        </div>
                      </Button>
                    </div>
                    <br />
                    <div className="mb-3 w-50 d-flex flex-column justify-content-center gap-3">
                      {optionfour === false ? (
                        <div className="uparrow square border border-danger">
                          <Lottie
                            // options={defaultOptionsNew}
                            animationData={up}
                            // height={80}
                            // width={80}
                            loop={true}
                            style={{ height: 80, width: 80 }}
                          />
                        </div>
                      ) : (
                        <div
                          className="downarrow square border border-success"
                          style={{ transform: "rotate(180deg)" }}
                        >
                          <Lottie
                            // options={defaultOptions}
                            animationData={down}
                            // height={80}
                            // width={80}
                            loop={true}
                            style={{ height: 80, width: 80 }}
                          />
                          {/* <Lottie
                          options={defaultOptionsNew}
                          height={150}
                          width={150}
                          
                        /> */}
                        </div>
                      )}
                      {optionfour === false ? (
                        <div className="increased-values arrowWaters">
                          {percentage}
                          <CaretUpOutlined style={{ color: "red" }} />
                        </div>
                      ) : (
                        <div className="increased-values arrowWater">
                          {percentage}
                          <CaretDownOutlined style={{ color: "green" }} />
                        </div>
                      )}
                    </div>
                  </div>
                </Card>
              </div>
              <div className="col-12 col-lg">
                <Card bordered={false} className="criclebox h-full">
                  <div className="d-flex justify-content-between align-items-center pb-3">
                    <h2 className="text-blue fw-bold mb-0 flex-grow-1 h2-title">
                      Flow Health
                    </h2>
                  </div>
                  <div onClick={totalFlow}>
                    <div className="dchart">
                      <PieChart
                        data={[
                          {
                            title: "No Recent Flow",
                            value: safeValue(noflow),
                            color: "#06acee",
                          },
                          {
                            title: "Backflow",
                            value: safeValue(backflowper),
                            color: "#D13838",
                          },
                          {
                            title: "Leak Detected",
                            value: safeValue(leakper),
                            color: "#ff8c00",
                          },
                          {
                            title: "No Issue",
                            value: safeValue(noissueper),
                            color: "#32cd32",
                          },
                        ]}
                        lineWidth={30} // Controls thickness of the donut (like innerRadius)
                        radius={35} // Set pie size relative to viewBox
                        startAngle={360} // optional: rotate starting point
                        animate
                        // label={({ dataEntry }) => `${dataEntry.title}`}
                        labelStyle={{
                          fontSize: "6px",
                          fill: "#000",
                        }}
                        style={{ width: 430, height: 230 }}
                      />
                    </div>
                    {/* <Lottie
                            options={watertaps}
                            height={250}
                            width={250}
                          /> */}
                    <div className="text-center text-grey mb-3">
                      Breakdown of flow anomalies
                    </div>
                    <div className="error-flow ">
                      <div
                        className="d-flex mb-3 flow-box"
                        style={{ whiteSpace: "nowrap" }}
                        onClick={() => totalFlow("3")}
                      >
                        <span className="bg-blue"></span> No Recent Flow (
                        {recent})
                        {/* <tooltip title="Meters with No flow detected during the past 72 hours." style={{ marginLeft: 'auto' }}>
                        <InfoCircleOutlined className="ms-1 text-blue" style={{ fontSize: '14px'}} />
                        </tooltip> */}
                      </div>
                      <div
                        className="d-flex mb-3 flow-box align-items-center"
                        onClick={() => totalFlow("2")}
                      >
                        <span className="bg-red"></span> Backflow ({backflow})
                        <Space className="backflow-span">
                          <Popover
                            trigger="click"
                            content={
                              <div
                                style={{
                                  width: "250px",
                                  textAlign: "left",
                                }}
                              >
                                A condition in which reverse water flow of more
                                than 1 gallon has been reported in the past 30
                                days. Clears when no backflow is detected for 30
                                consecutive days.
                              </div>
                            }
                            placement="top"
                            getPopupContainer={(trigger) =>
                              trigger.parentElement
                            }
                          >
                            <InfoCircleOutlined
                              onClick={(e) => e.stopPropagation()}
                              style={{
                                color: "#1890ff",
                                cursor: "pointer",
                                marginTop: "0px",
                              }}
                            />
                          </Popover>
                        </Space>
                      </div>
                      <div
                        className="d-flex mb-3 flow-box"
                        style={{ whiteSpace: "nowrap" }}
                        onClick={() => totalFlow("1")}
                      >
                        <span className="bg-orange"></span> Leak Detected (
                        {leak})
                        {/* <tooltip title="Indicates locations where flow has been detected every hour in a 24-hour period." style={{ marginLeft: 'auto' }}>
                        <InfoCircleOutlined className="ms-1 text-blue" style={{ fontSize: '14px'}} />
                        </tooltip> */}
                      </div>
                      <div className="d-flex mb-3 flow-box">
                        <span className="bg-green"></span> No Issue ({noissue})
                      </div>
                    </div>
                  </div>
                </Card>
              </div>
            </div>
            {/* new */}

            <div className="layout-content mt-4">
              <div className="container-fluid px-0 flex-column">
                <div className="row g-3">
                  <div
                    className={`col-sm-12 ${
                      selectedDistrict?.selectedDistrict === "FB151"
                        ? "col-lg-12"
                        : "col-lg-8"
                    }`}
                  >
                    <div className="card card-box-style h-full pb-0">
                      <div className="card-body d-flex justify-content-between align-items-start">
                        <div className="inside-box-left">
                          <div class="d-flex justify-content-start align-items-center gap-2">
                            <h2 className="text-blue mb-0 fw-bold h2-title">
                              Total Consumption
                            </h2>
                            <Space className="me-3">
                              <Popover
                                trigger="click"
                                content={
                                  <div
                                    style={{
                                      width: "250px",
                                      textAlign: "left",
                                    }}
                                  >
                                    Total consumption for last 30 days in
                                    Gallons
                                  </div>
                                }
                                placement="top"
                                getPopupContainer={(trigger) =>
                                  trigger.parentElement
                                }
                              >
                                <InfoCircleOutlined
                                  onClick={(e) => e.stopPropagation()}
                                  style={{
                                    color: "#1890ff",
                                    cursor: "pointer",
                                    marginTop: "8px",
                                  }}
                                />
                              </Popover>
                            </Space>
                          </div>
                          {/* <p className="text-gray fw-400 fs-14 mt-2">
                            <span className="text-blue">*</span> Total
                            consumption for last 30 days in Gallons
                          </p> */}

                          <div className="card-text mt-3">
                            {yearlyConsumption ? (
                              <div className="margin-top-trend">
                                {/* {[
                                  {
                                    label: "Plant Demand",
                                    value: yearlyConsumption.demand,
                                  },
                                  {
                                    label: "Plant Intake",
                                    value: yearlyConsumption.produced,
                                  },
                                  {
                                    label: "Plant Supply",
                                    value: yearlyConsumption.supply,
                                  }, */}
                                {(selectedDistrict?.selectedDistrict === "FB151"
                                  ? [
                                      {
                                        label: "Total Demand",
                                        value: yearlyConsumption.demand,
                                      },
                                      {
                                        label: "Total Supply",
                                        value: yearlyConsumption.supply,
                                      },
                                    ]
                                  : [
                                      {
                                        label: "Plant Demand",
                                        value: yearlyConsumption.demand,
                                      },
                                      {
                                        label: "Plant Intake",
                                        value: yearlyConsumption.produced,
                                      },
                                      {
                                        label: "Plant Supply",
                                        value: yearlyConsumption.supply,
                                      },
                                    ]
                                ).map(({ label, value }) => (
                                  <div
                                    className="d-flex align-items-end trends-align padding-trends"
                                    key={label}
                                  >
                                    <div className="w-50 me-2">
                                      <font size="3" className="capacity-size">
                                        <b style={{ fontWeight: "400" }}>
                                          {label}
                                        </b>
                                      </font>
                                    </div>
                                    <div className="w-50 text-right">
                                      <font
                                        size="3"
                                        className="capacity-size capacity-space"
                                      >
                                        <b>:</b>{" "}
                                        <b className="space-left">{value}</b>
                                      </font>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div className="text-center">
                                <Spin />
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="inside-line"></div>

                        <div className="inside-box-right">
                          <div class="d-flex justify-content-start align-items-center gap-2">
                            <h2 className="text-blue mb-0 fw-bold h2-title">
                              Average Accountability
                            </h2>
                            <Space className="me-3">
                              <Popover
                                trigger="click"
                                content={
                                  <div
                                    style={{
                                      width: "250px",
                                      textAlign: "left",
                                    }}
                                  >
                                    Average accountability for last 30 days
                                  </div>
                                }
                                placement="top"
                                getPopupContainer={(trigger) =>
                                  trigger.parentElement
                                }
                              >
                                <InfoCircleOutlined
                                  onClick={(e) => e.stopPropagation()}
                                  style={{
                                    color: "#1890ff",
                                    cursor: "pointer",
                                    marginTop: "8px",
                                  }}
                                />
                              </Popover>
                            </Space>
                          </div>
                          {/* <p className="text-gray fw-400 fs-14 mt-2">
                            <span className="text-blue">*</span> Average
                            accountability for last 30 days
                          </p> */}

                          <div className="card-text mt-3">
                            {accountability ? (
                              <div className="margin-top-trend">
                                {/* {[
                                  { label: "Non-Potable", value: accountability.nonPotable },
                                  { label: "Potable", value: accountability.potable },
                                  { label: "Plant", value: accountability.total }, */}
                                {(selectedDistrict?.selectedDistrict === "FB151"
                                  ? [
                                      {
                                        label: "Total",
                                        value: accountability.total,
                                      },
                                    ]
                                  : [
                                      {
                                        label: "Non-Potable",
                                        value: accountability.nonPotable,
                                      },
                                      {
                                        label: "Potable",
                                        value: accountability.potable,
                                      },
                                      {
                                        label: "Plant",
                                        value: accountability.total,
                                      },
                                    ]
                                ).map((item) => (
                                  <div
                                    className="d-flex align-items-center trends-align padding-trends"
                                    key={item.label}
                                  >
                                    <div className="w-50 me-2">
                                      <font size="3" className="capacity-size">
                                        <b style={{ fontWeight: "400" }}>
                                          {item.label}
                                        </b>
                                      </font>
                                    </div>
                                    <div className="w-50 text-right">
                                      <font
                                        size="3"
                                        className="capacity-size capacity-space"
                                      >
                                        <b>:</b>
                                        <b className="space-left-sec">
                                          {item.value}%
                                        </b>
                                      </font>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div className="text-center">
                                <Spin />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {selectedDistrict?.selectedDistrict === "GPMD" ? (
                    <>
                      <div className="col-sm-12 col-lg-4">
                        <div className="card card-box-style pb-0 h-full">
                          <div className="card-body">
                            <div className="d-flex align-items-center justify-content-between mb-3 dropdown-fix">
                              <h2 className="text-blue mb-0 fw-bold h2-title">
                                Capacity Planning
                              </h2>
                              <select
                                name="All meters"
                                id="selector"
                                className="boxd"
                                onChange={onMouseClickcapacity}
                              >
                                <option value="gallons" selected>
                                  Gallons/Day
                                </option>
                                <option value="COH">
                                  Equivalent connection – COH
                                </option>
                                <option value="TCEQ">
                                  {" "}
                                  Equivalent connection – TCEQ
                                </option>
                              </select>
                            </div>
                            <div className="card-text">
                              {" "}
                              {spindata ? (
                                <>
                                  <div className="d-flex align-items-end trends-align">
                                    <div className="title-left me-2">
                                      <font size="3" className="capacity-size">
                                        <b style={{ fontWeight: "400" }}>
                                          {totalcapacitylimit}
                                        </b>{" "}
                                      </font>
                                    </div>
                                    <div className="result-right text-right">
                                      <font
                                        size="3"
                                        className="capacity-size capacity-space"
                                      >
                                        <b>:</b>
                                        <b className="space-left-sec">
                                          {limit}
                                        </b>
                                      </font>
                                    </div>
                                  </div>

                                  <div className="d-flex  align-items-baseline  trends-align">
                                    <div className="title-left  me-2">
                                      <font size="3" className="capacity-size ">
                                        <b style={{ fontWeight: "400" }}>
                                          {allocatedcapacity}
                                        </b>{" "}
                                      </font>
                                    </div>
                                    <div className="result-right text-right">
                                      <font
                                        size="3"
                                        className="capacity-size capacity-space"
                                      >
                                        {" "}
                                        <b>:</b>
                                        <b className="space-left-sec">
                                          {inactive}
                                        </b>
                                      </font>
                                    </div>
                                  </div>

                                  <div className="d-flex  align-items-baseline  trends-align">
                                    <div className="title-left  me-2">
                                      <font size="3" className="capacity-size ">
                                        <b style={{ fontWeight: "400" }}>
                                          {capacityname}
                                        </b>{" "}
                                      </font>
                                    </div>
                                    <div className="result-right text-right">
                                      <font
                                        size="3"
                                        className="capacity-size capacity-space"
                                      >
                                        <b>:</b>
                                        <b className="space-left-sec">
                                          {allocated}
                                        </b>
                                      </font>
                                    </div>
                                  </div>

                                  <div className="d-flex  align-items-baseline  trends-align">
                                    <div className="title-left  me-2">
                                      <font size="3" className="capacity-size ">
                                        <b style={{ fontWeight: "400" }}>
                                          {totaluse}
                                          <span> (12 months)</span>
                                        </b>{" "}
                                      </font>
                                    </div>
                                    <div className="result-right text-right">
                                      <font
                                        size="3"
                                        className="capacity-size capacity-space"
                                      >
                                        <b>:</b>{" "}
                                        <b className="space-left-sec">{use}</b>
                                      </font>
                                    </div>
                                  </div>

                                  <div className="d-flex  align-items-baseline  trends-align">
                                    <div className="title-left  me-2">
                                      <font size="3" className="capacity-size">
                                        <b style={{ fontWeight: "400" }}>
                                          {sumname}
                                          <span> (12 months) </span> (
                                          <span>{date}</span>)
                                        </b>{" "}
                                      </font>
                                    </div>
                                    <div className="result-right text-right">
                                      <font
                                        size="3"
                                        className="capacity-size capacity-space"
                                      >
                                        {" "}
                                        <b>:</b>{" "}
                                        <b className="space-left-sec">{sum}</b>
                                      </font>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <div className="text-center">
                                  {" "}
                                  <Spin />{" "}
                                </div>
                              )}{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                {/* end */}
              </div>
            </div>
            {/* end new */}

            <div className="bottom-layout mt-4">
              <div className="row">
                {/* <div className="row">
                  <div className="card-deck row">
                  </div>
                </div> */}
                <div className="col-md-12 mb-1">
                  <div className="d-flex align-items-center">
                    {/* <div className="d-flex align-items-center mb-3"> */}
                    <div class="d-flex justify-content-start align-items-center gap-2">
                      <h2 className="text-blue mb-0 fw-bold h2-title">Trend</h2>
                      <Space className="me-3">
                        <Popover
                          trigger="click"
                          content={
                            <div
                              style={{
                                width: "250px",
                                textAlign: "left",
                              }}
                            >
                              Aggregated view of data across the selected period
                              to analyze overall trends.
                            </div>
                          }
                          placement="top"
                          getPopupContainer={(trigger) => trigger.parentElement}
                        >
                          <InfoCircleOutlined
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              color: "#1890ff",
                              cursor: "pointer",
                              marginTop: "8px",
                            }}
                          />
                        </Popover>
                      </Space>
                    </div>
                    {/* <p className="text-grey fs-18 mb-0 ps-3">
                      (See aggregated data flow)
                    </p> */}
                    {/* </div> */}
                  </div>
                </div>
                <div className="dropdownCategories graph-dropdown d-flex align-items-center justify-content-between flex-column bg-white pt-2">
                  <div className="d-flex align-items-center justify-content-between w-100">
                    <div className="set-width mt-0">
                      <div className="row ps-1">
                        <div className="col-6">
                          <Select
                            getPopupContainer={(trigger) => trigger.parentNode}
                            defaultValue="Total"
                            suffixIcon={<CaretDownOutlined />}
                            onChange={onSelects}
                            className="increased-values text-grey  "
                            bordered={false}
                          >
                            <Option value="account">Account</Option>
                            <Option value="category">Total</Option>
                          </Select>
                        </div>

                        {defaultOptionss === "Account" ? (
                          <div className="col-6 multiselectDropdownStyle">
                            <Example
                              parentCallback={handleCallback}
                              elementValue={myData}
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div id="1st" className="col ps-0 set-date-year mt-0">
                      <div className="d-flex gap-1  selectCalender calender-new ms-auto">
                        <Select
                          defaultValue="year"
                          style={{
                            width: 120,
                          }}
                          bordered={false}
                          onChange={onSelect}
                        >
                          <Option value="year">Year</Option>
                          <Option value="month">Month</Option>
                          <Option value="week">Week</Option>
                          <Option value="quarter">Quarter</Option>
                          <Option value="day">Day</Option>
                        </Select>
                        {defaultOptionss === "Account" ? (
                          <Space direction="horizontal" size={1}>
                            {defaultOption === "Year" ? (
                              <>
                                <DatePicker
                                  picker="year"
                                  disabledDate={disabledDate}
                                  onChange={onchanges}
                                  defaultValue={defaultStartYear}
                                />
                                <SwapOutlined
                                  style={{
                                    alignSelf: "center",
                                    marginBottom: "0",
                                    lineHeight: "0",
                                    padding: "0 8px",
                                    color: "#5c5c5c",
                                    fontSize: "13px",
                                  }}
                                />
                                <DatePicker
                                  picker="year"
                                  disabledDate={disabledDate}
                                  onChange={onchangess}
                                  defaultValue={defaultEndYear}
                                />
                              </>
                            ) : (
                              ""
                            )}

                            {defaultOption === "Month" ? (
                              <>
                                {" "}
                                <DatePicker
                                  picker="month"
                                  disabledDate={disabledDate}
                                  onChange={onchanges}
                                />
                                <SwapOutlined
                                  style={{
                                    alignSelf: "center",
                                    marginBottom: "0",
                                    lineHeight: "0",
                                    padding: "0 8px",
                                    color: "#5c5c5c",
                                    fontSize: "13px",
                                  }}
                                />
                                <DatePicker
                                  picker="month"
                                  onChange={onchangess}
                                />
                              </>
                            ) : (
                              ""
                            )}
                            {defaultOption === "Week" ? (
                              <>
                                {" "}
                                <DatePicker
                                  picker="week"
                                  onChange={onchanges}
                                  disabledDate={disabledDate}
                                  // defaultValue={
                                  //   moment(Date.now() - (3600 * 1000 * 24 * 7))

                                  // }
                                />
                                <SwapOutlined
                                  style={{
                                    alignSelf: "center",
                                    marginBottom: "0",
                                    lineHeight: "0",
                                    padding: "0 8px",
                                    color: "#5c5c5c",
                                    fontSize: "13px",
                                  }}
                                />
                                <DatePicker
                                  picker="week"
                                  disabledDate={disabledDate}
                                  onChange={onchangess}
                                  // defaultValue={
                                  //   moment(new Date())

                                  // }
                                />{" "}
                              </>
                            ) : (
                              ""
                            )}
                            {defaultOption === "Quarter" ? (
                              <>
                                {" "}
                                <DatePicker
                                  picker="quarter"
                                  disabledDate={disabledDate}
                                  onChange={onchanges}
                                />
                                <SwapOutlined
                                  style={{
                                    alignSelf: "center",
                                    marginBottom: "0",
                                    lineHeight: "0",
                                    padding: "0 8px",
                                    color: "#5c5c5c",
                                    fontSize: "13px",
                                  }}
                                />
                                <DatePicker
                                  picker="quarter"
                                  disabledDate={disabledDate}
                                  onChange={onchangess}
                                />
                              </>
                            ) : (
                              ""
                            )}
                            {defaultOption === "Day" ? (
                              <>
                                <DatePicker
                                  onChange={onchanges}
                                  disabledDate={disabledDate}
                                />
                                <SwapOutlined
                                  style={{
                                    alignSelf: "center",
                                    marginBottom: "0",
                                    lineHeight: "0",
                                    padding: "0 8px",
                                    color: "#5c5c5c",
                                    fontSize: "13px",
                                  }}
                                />
                                <DatePicker onChange={onchangess} />
                              </>
                            ) : (
                              ""
                            )}
                          </Space>
                        ) : (
                          <Space direction="horizontal" size={1}>
                            {defaultOption === "Year" ? (
                              <RangePicker
                                picker="year"
                                disabledDate={disabledDate}
                                onChange={onchange}
                                defaultValue={[
                                  defaultStartYear,
                                  defaultEndYear,
                                ]}
                                separator={<SwapOutlined />}
                              />
                            ) : (
                              ""
                            )}
                            {defaultOption === "Month" ? (
                              <RangePicker
                                picker="month"
                                disabledDate={disabledDate}
                                onChange={onchange}
                                separator={<SwapOutlined />}
                              />
                            ) : (
                              ""
                            )}
                            {defaultOption === "Week" ? (
                              <RangePicker
                                picker="week"
                                onChange={onchange}
                                disabledDate={disabledDate}
                                separator={<SwapOutlined />}
                              />
                            ) : (
                              ""
                            )}
                            {defaultOption === "Quarter" ? (
                              <RangePicker
                                picker="quarter"
                                disabledDate={disabledDate}
                                onChange={onchange}
                                separator={<SwapOutlined />}
                              />
                            ) : (
                              ""
                            )}
                            {defaultOption === "Day" ? (
                              <RangePicker
                                onChange={onchange}
                                disabledDate={disabledDate}
                                separator={<SwapOutlined />}
                              />
                            ) : (
                              ""
                            )}
                          </Space>
                        )}
                      </div>
                    </div>
                    <div className="ms-2">
                      <div className="ml-auto downloadss">
                        {defaultOptionss === "Account" ? (
                          <Dropdown
                            menu={{ items: item }}
                            getPopupContainer={(trigger) => trigger.parentNode}
                            trigger={["click"]}
                          >
                            <a onClick={(e) => e.preventDefault()}>
                              <Space>
                                <img
                                  src={download}
                                  alt="download"
                                  style={{ width: "27px" }}
                                  title="Download"
                                />
                              </Space>
                            </a>
                          </Dropdown>
                        ) : (
                          <Dropdown
                            getPopupContainer={(trigger) => trigger.parentNode}
                            menu={{ items: items }}
                            // menu={{
                            //   items,
                            // }}
                            trigger={["click"]}
                          >
                            <a onClick={(e) => e.preventDefault()}>
                              <Space>
                                <img
                                  src={download}
                                  alt="download"
                                  style={{ width: "25px" }}
                                  title="Download"
                                />
                                {/* <CaretDownOutlined /> */}
                              </Space>
                            </a>
                          </Dropdown>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* .................................................................................................................................. */}

                  <div className="row w-100">
                    {defaultOptionss === "Account" ? (
                      <>
                        <div className="col-12 col-lg-3 ps-1">
                          <div className="water-accountList border rounded pt-2 water-section-home">
                            {callData?.map((person, index) => (
                              <div key={index}>
                                <ul className="p-0">
                                  <h5 className="py-2">
                                    {person.Overide_acc_name}
                                  </h5>
                                  {person.meters.map((meter, index) => (
                                    <>
                                      <li
                                        className="d-flex align-items-center gap-3"
                                        onClick={add(
                                          meter.unique_name,
                                          meter.meter_unique_name,
                                          meter.overided_name.substring(0, 12),
                                          meter.code,
                                          meter.name.substring(0, 12),
                                          index,

                                          count,
                                        )}
                                      >
                                        {myData?.includes(
                                          meter.meter_unique_name,
                                        ) ? (
                                          <div>
                                            <DashboardOutlined
                                              style={{
                                                fontSize: "36px",
                                                color:
                                                  color[
                                                    myData.indexOf(
                                                      meter.meter_unique_name,
                                                    )
                                                  ],
                                              }}
                                            />
                                          </div>
                                        ) : (
                                          <div>
                                            <DashboardOutlined className="dashboardIcon icon-color" />
                                          </div>
                                        )}
                                        <div className="water-enterprises">
                                          <div className="d-flex justify-content-between align-items-center flex-wrap">
                                            <h5 className="mb-0">
                                              {" "}
                                              {meter.name}
                                            </h5>{" "}
                                            <span>
                                              <div
                                                style={{
                                                  display: "flex",
                                                }}
                                              >
                                                <div>{meter.meter_id}</div>
                                                {meter.register_number ? (
                                                  <div>
                                                    ({meter.register_number})
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </div>
                                            </span>
                                          </div>
                                          <div>
                                            Date Range: {meter.date_range}
                                          </div>
                                        </div>
                                      </li>{" "}
                                      <hr />
                                    </>
                                  ))}
                                </ul>
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    {defaultOptionss === "Category" ? (
                      <>
                        {" "}
                        <div
                          className="col-12 col-lg-12 position-relative bg-white py-3"
                          id="domEl"
                          ref={domEl}
                        >
                          <div className="d-flex gap-2 chartTab justify-content-end">
                            <div
                              style={{
                                border: "1px solid #ccc",
                                padding: "0.5rem",
                                borderRadius: "4px",
                                marginRight: "15px",
                              }}
                            >
                              <img
                                src={diagram}
                                alt=""
                                onClick={lineClick}
                                style={{ width: "30px", cursor: "pointer" }}
                              />
                            </div>
                            <div
                              style={{
                                border: "1px solid #ccc",
                                padding: "0.5rem",
                                borderRadius: "4px",
                              }}
                            >
                              <img
                                src={chart}
                                alt=""
                                onClick={barClick}
                                style={{ width: "30px", cursor: "pointer" }}
                              />
                            </div>
                          </div>
                          {toggle === true ? (
                            <div
                              style={{
                                maxWidth: "100%",
                                margin: "0 auto",
                                height: "500px",
                              }}
                              className="line-chart"
                            >
                              <ResponsiveContainer>
                                <LineChart
                                  data={arrayData}
                                  margin={{
                                    top: 5,
                                    right: 5,
                                    left: 20,
                                    bottom: 5,
                                  }}
                                >
                                  <XAxis dataKey="name" />
                                  <YAxis
                                    tickFormatter={(value) =>
                                      value.toLocaleString()
                                    }
                                  />

                                  <Legend />

                                  <Line
                                    type="monotone"
                                    dataKey={parameterone}
                                    stroke={color[0]}
                                    activeDot={{ r: 8 }}
                                    fill={color[0]}
                                    strokeWidth={3}
                                    // name={
                                    //   defaultOptionss === "Category"
                                    //     ? `${parameterone} (Actual)`
                                    //     : parameterone
                                    // }
                                    name={
                                      defaultOptionss === "Category" &&
                                      parametertwo?.toString() ===
                                        currentYear.toString()
                                        ? `${parameterone} (Actual)`
                                        : parameterone
                                    }
                                  />
                                  <Line
                                    type="monotone"
                                    dataKey={parametertwo}
                                    stroke={color[1]}
                                    fill={color[1]}
                                    strokeWidth={3}
                                    // name={
                                    //   defaultOptionss === "Category"
                                    //     ? `${parametertwo} (YTD)`
                                    //     : parametertwo
                                    // }
                                    name={
                                      defaultOptionss === "Category" &&
                                      parametertwo?.toString() ===
                                        currentYear.toString()
                                        ? `${parametertwo} (YTD)`
                                        : parametertwo
                                    }
                                  />
                                  <CartesianGrid stroke="lightGrey" />
                                  <Tooltip
                                    formatter={(value) =>
                                      value.toLocaleString()
                                    }
                                  />
                                </LineChart>
                              </ResponsiveContainer>
                            </div>
                          ) : (
                            <div
                              style={{
                                maxWidth: "100%",
                                margin: "0 auto",
                                height: "500px",
                              }}
                              className="bar-line-style"
                            >
                              <ResponsiveContainer width="100%" height="100%">
                                <BarChart
                                  id="canvas"
                                  width={1660}
                                  height={600}
                                  margin={{
                                    top: 5,
                                    right: 30,
                                    left: 20,
                                    bottom: 5,
                                  }}
                                  data={arrayData}
                                >
                                  <CartesianGrid strokeDasharray="3 3" />
                                  <XAxis dataKey="name" />
                                  <YAxis
                                    tickFormatter={(value) =>
                                      value.toLocaleString()
                                    }
                                  />

                                  <Tooltip
                                    formatter={(value) =>
                                      value.toLocaleString()
                                    }
                                  />
                                  <Legend />
                                  <Bar
                                    dataKey={parameterone}
                                    fill={color[0]}
                                    // name={`${parameterone} (Actual)`}
                                    name={
                                      parametertwo?.toString() ===
                                      currentYear.toString()
                                        ? `${parameterone} (Actual)`
                                        : parameterone
                                    }
                                  />
                                  <Bar
                                    dataKey={parametertwo}
                                    fill={color[1]}
                                    // name={`${parametertwo} (YTD)`}
                                    name={
                                      parametertwo?.toString() ===
                                      currentYear.toString()
                                        ? `${parametertwo} (YTD)`
                                        : parametertwo
                                    }
                                  />
                                </BarChart>
                              </ResponsiveContainer>
                            </div>
                          )}
                          <div className="labelYAxis">{getYAxisLabel()}</div>
                        </div>
                      </>
                    ) : (
                      <>
                        {" "}
                        <div
                          className="col-12 col-lg-9 position-relative bg-white py-3"
                          id="domEl"
                          ref={domEl}
                        >
                          <div className="d-flex gap-2 chartTab justify-content-end">
                            <div className="ml-auto downloadss"></div>

                            <div className="line-graph">
                              <p className="mb-1">
                                <span className="line-bar"> </span>{" "}
                                <span> {parameterthree} </span>
                              </p>
                              <p>
                                <span className="dot-bar"></span>{" "}
                                <span>{parameterfour} </span>
                              </p>
                            </div>

                            <div
                              style={{
                                border: "1px solid #ccc",
                                padding: "0.5rem",
                                borderRadius: "4px",
                              }}
                            >
                              <img
                                src={diagram}
                                alt=""
                                onClick={lineClick}
                                style={{ width: "30px", cursor: "pointer" }}
                              />
                            </div>
                          </div>

                          <div
                            style={{
                              maxWidth: "100%",
                              margin: "0 auto",
                              height: "600px",
                            }}
                            className="need-scroll ms-adjust"
                          >
                            <ResponsiveContainer>
                              <LineChart
                                data={merge}
                                margin={{
                                  top: 5,
                                  right: 20,
                                  left: 20,
                                  bottom: 5,
                                }}
                              >
                                <XAxis dataKey="name" />
                                <YAxis
                                  tickFormatter={(value) =>
                                    value.toLocaleString()
                                  }
                                />

                                {myDatas?.map((item, index) => (
                                  <Line
                                    type="monotone"
                                    key={`line-${item.meter}`}
                                    dataKey={item.meter}
                                    stroke={color[index]}
                                    fill={color[index]}
                                    strokeWidth={3}
                                  />
                                ))}
                                {myDatanew?.map((item, index) => (
                                  <Line
                                    type="monotone"
                                    key={`line-new-${item}`}
                                    dataKey={item}
                                    stroke={color[index]}
                                    fill={color[index]}
                                    strokeDasharray="5 5"
                                    strokeWidth={3}
                                  />
                                ))}
                                <CartesianGrid stroke="lightGrey" />

                                <Tooltip
                                  content={<CustomTooltip />}
                                  cursor={{ fill: "transparent" }}
                                  formatter={(value) => value.toLocaleString()}
                                />
                              </LineChart>
                            </ResponsiveContainer>
                          </div>

                          <div className="labelYAxis">
                            Consumption (Gallons)
                          </div>
                          <div className="px-5 d-flex flex-wrap justify-content-start align-items-center mb-5">
                            {myDatas?.map((item, index) => (
                              <>
                                <div className="d-flex me-3 mb-2">
                                  <div
                                    style={{
                                      width: 15,
                                      height: 15,
                                      backgroundColor: color[index],
                                      marginRight: 6,
                                    }}
                                  ></div>
                                  <span style={{ width: "280px" }}>
                                    <font color={color[index]}>
                                      {item.meter}-{item.overide}[{item.code}]
                                    </font>
                                  </span>
                                </div>
                              </>
                            ))}
                          </div>
                        </div>
                      </>
                    )}
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {open === true ? (
          <Modal
            title="Add / Remove Modules"
            open={open}
            onOk={handleOk}
            confirmLoading={confirmLoading}
            onCancel={handleCancel}
            centered="true"
            width={1300}
          >
            <div className="row bg-light rounded p-3">
              <div className="col-12 col-lg-4 rounded shadow p-0">
                <Card
                  bordered={false}
                  className="h-full d-flex justify-content-between w-100 flex-wrap rounded"
                  onClick={onHealth}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <h6 className="text-blue mb-0 fw-bold">System Health</h6>
                    <div class="dotted-dropdown">
                      <MoreOutlined />
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between h-85">
                    <div className="reg_heart">
                      {" "}
                      <Lottie
                        // options={defaultOptionsNews}
                        animationData={beatingheart}
                        // height={200}
                        // width={100}
                        loop={true}
                        style={{ height: 200, width: 100 }}
                        direction={-1}
                      />
                      {/* <div className="border-green text-green text-center p-2 fs-18 rounded">Status: Healthy</div> */}
                      <div className="border-red text-red text-center p-1 fs-14 rounded">
                        Status: Unhealthy
                      </div>
                      {/* <div className="border-orange text-orange text-center p-2 fs-18 rounded">Status: Unhealthy</div> */}
                    </div>
                    <div className="error-box gap-2">
                      <div className="d-flex mb-3">
                        <span className="bg-green"></span> Data Status
                      </div>
                      <div className="d-flex mb-3">
                        <span className="bg-red"></span>Device Status
                      </div>
                      <div className="d-flex mb-3">
                        <span className="bg-orange"></span> Communication Status
                      </div>
                    </div>
                  </div>
                </Card>
              </div>
              <div className="col-12 col-lg-8 d-flex flex-column align-items-start justify-content-between">
                <div>
                  <h5>System Health</h5>
                  <p>
                    This health module gives utilities a snapshot of the number
                    and percentage of devices, encoders and meters–reporting
                    with and without issues. Use the drop-down menu to examine
                    all devices or the devices you have marked as Favorites.
                    Scroll up and down using the gray elevator bar on the
                    right-hand side of the module.
                  </p>
                </div>
                <button className="btn btn-danger d-flex rounded-0 px-4">
                  Remove
                </button>
              </div>
            </div>
            <hr />
            <div className="row bg-light rounded p-3">
              <div className="col-12 col-lg-4 rounded shadow p-0">
                <Card bordered={false} className="criclebox h-full">
                  <div className="d-flex justify-content-between align-items-center pb-1">
                    <h6 className="text-blue mb-0 fw-bold flex-grow-1">
                      System Water Usage
                    </h6>
                    <select
                      name="All meters"
                      id="selector"
                      className="box"
                      onChange={onMouseClick}
                    >
                      <option value="week" selected>
                        Week
                      </option>
                      <option value="month">Month </option>
                      <option value="year">Year</option>

                      <option value="Last Week">Last Week</option>
                      <option value="Last Month">Last Month </option>
                      <option value="Last Year">Last Year</option>
                    </select>
                    <div className="dotted-dropdown">
                      <CaretDownOutlined />
                    </div>
                  </div>

                  <h6 className="fw-400 text-grey mb-0">
                    Weekly Usage(Gallons/Week)
                    <span className="text-blue">*</span>
                  </h6>
                  <p className="text-gray fw-400 fs-12">
                    <span className="text-blue">*</span>This metric is
                    calculated from networked meters only
                  </p>
                  <div className="d-flex justify-content-between flex-wrap">
                    <div className="water-usage flex-column w-50 gap-3">
                      <Button type="btn" className="border-0 shadow-0 d-flex">
                        <div className="this_week">
                          {selected === "week" ? (
                            <span className="txt-week">This Week</span>
                          ) : (
                            ""
                          )}
                          {selected === "month" ? (
                            <span className="txt-week">This Month</span>
                          ) : (
                            ""
                          )}
                          {selected === "year" ? (
                            <span className="txt-week">This Year</span>
                          ) : (
                            ""
                          )}
                          <span className="usage-numberNew">{optionone}</span>
                          <span className="txt-gallonNew">Gallons</span>
                        </div>
                      </Button>

                      <Button type="btn" className="border-0 shadow-0 d-flex">
                        <div className="last_week">
                          {selected === "week" ? (
                            <span className="txt-week">Last Week</span>
                          ) : (
                            ""
                          )}
                          {selected === "month" ? (
                            <span className="txt-week">Last Month</span>
                          ) : (
                            ""
                          )}
                          {selected === "year" ? (
                            <span className="txt-week">Last Year</span>
                          ) : (
                            ""
                          )}
                          <span className="usage-numberNew">{optiontwo}</span>
                          <span className="txt-gallonNew">Gallons</span>
                        </div>
                      </Button>
                    </div>
                    <br />
                    <div className="mb-3 w-50 d-flex flex-column justify-content-center gap-3">
                      {optionfour === false ? (
                        <div className="uparrow">
                          <Lottie
                            // options={defaultOptionsNew}
                            animationData={up}
                            // height={80}
                            // width={80}
                            loop={true}
                            style={{ height: 80, width: 80 }}
                          />
                        </div>
                      ) : (
                        <div className="downarrow">
                          <Lottie
                            animationData={down}
                            // options={defaultOptions}
                            // height={130}
                            // width={130}
                            loop={true}
                            style={{ height: 130, width: 130 }}
                          />
                        </div>
                      )}
                      {optionfour === false ? (
                        <div className="increased-values">
                          {percentage}
                          <CaretUpOutlined style={{ color: "red" }} />
                        </div>
                      ) : (
                        <div className="increased-values arrowWater">
                          {percentage}
                          <CaretDownOutlined style={{ color: "green" }} />
                        </div>
                      )}
                    </div>
                  </div>
                </Card>
              </div>
              <div className="col-12 col-lg-8 d-flex flex-column align-items-start justify-content-between">
                <div>
                  <h5>System Health</h5>
                  <p>
                    This health module gives utilities a snapshot of the number
                    and percentage of devices, encoders and meters–reporting
                    with and without issues. Use the drop-down menu to examine
                    all devices or the devices you have marked as Favorites.
                    Scroll up and down using the gray elevator bar on the
                    right-hand side of the module.
                  </p>
                </div>
                <button className="btn btn-success d-flex rounded-0 px-4">
                  Add
                </button>
              </div>
            </div>
          </Modal>
        ) : (
          ""
        )}
      </Main>
    </>
  );
}

export default Home;
